import { SALES_PHONE_NUMBER } from '@seek/shared-constants';

export const asiaSites = [
  'employer-seek-hk',
  'employer-seek-th',
  'employer-seek-sg',
  'employer-seek-id',
  'employer-seek-ph',
  'employer-seek-my',
];

export const isAnzSite = (
  site: string,
): site is keyof typeof SALES_PHONE_NUMBER =>
  Object.keys(SALES_PHONE_NUMBER).includes(site);
